import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-form-visualizacao-xml',
    templateUrl: './formvisualizacaoxml.component.html',
    styleUrls: ['./formvisualizacaoxml.component.css']
})
export class FormVisualizacaoXmlComponent implements OnInit {

      xmlsProcessados: any[] = [];
    xmlSelecionado: any = null;
    activeIndex: number = 0;
    
    // Variáveis de pesquisa
    textoPesquisa: string = '';
    itensFiltrados: any[] = [];

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) { }

    ngOnInit(): void {
        const todosItens = this.config.data.itens;
        
        // Agrupa itens por arquivo XML
        const xmlsMap = new Map<string, any>();
        
        todosItens.forEach((item: any) => {
            if (!xmlsMap.has(item.arquivo)) {
                xmlsMap.set(item.arquivo, {
                    arquivo: item.arquivo,
                    cabecalho: item.cabecalho,
                    itens: []
                });
            }
            xmlsMap.get(item.arquivo).itens.push(item);
        });
        
        this.xmlsProcessados = Array.from(xmlsMap.values());
        
        if (this.xmlsProcessados.length > 0) {
            this.selecionarXml(this.xmlsProcessados[0]);
        }
    }

    selecionarXml(xml: any) {
        this.xmlSelecionado = xml;
        this.activeIndex = 0;
        this.textoPesquisa = '';
        this.aplicarFiltro();
    }

    aplicarFiltro() {
        if (!this.xmlSelecionado) {
            this.itensFiltrados = [];
            return;
        }

        if (!this.textoPesquisa || this.textoPesquisa.trim() === '') {
            this.itensFiltrados = [...this.xmlSelecionado.itens];
            return;
        }

        const termo = this.textoPesquisa.toLowerCase().trim();
        
        this.itensFiltrados = this.xmlSelecionado.itens.filter((item: any) => {
            return (
                item.pn?.toLowerCase().includes(termo) ||
                item.ncmXml?.toLowerCase().includes(termo) ||
                item.descricao?.toLowerCase().includes(termo) ||
                item.numeroItem?.toString().includes(termo) ||
                item.ncmSistema?.toLowerCase().includes(termo)
            );
        });
    }

    limparPesquisa() {
        this.textoPesquisa = '';
        this.aplicarFiltro();
    }

    fechar() {
        this.ref.close();
    }

    formatarValor(valor: any): string {
        if (!valor) return '-';
        
        if (!isNaN(valor)) {
            return parseFloat(valor).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
        
        return valor;
    }

    formatarData(data: string): string {
        if (!data) return '-';
        return data;
    }
}
